"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
class Dropdown extends react_1.default.Component {
    constructor(props, view) {
        super(props);
        this.ref = react_1.default.createRef();
        this.state = {
            isOpen: false,
        };
        this.view = view;
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
        document.addEventListener('click', this.handleMouseClick.bind(this));
        window.addEventListener('popstate', this.close);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown.bind(this));
        document.removeEventListener('click', this.handleMouseClick.bind(this));
    }
    render() {
        const componentView = this.view;
        return componentView(this.props, this.state.isOpen, this.ref);
    }
    open() {
        this.setState({
            isOpen: true,
        });
    }
    close() {
        this.setState({
            isOpen: false,
        });
    }
    handleKeyDown(event) {
        if (event.keyCode === 27 && this.state.isOpen) {
            this.close();
        }
    }
    handleMouseClick(event) {
        const dropdown = this.ref.current;
        const isClickedOutsideDropdown = dropdown && !dropdown.contains(event.target);
        if (isClickedOutsideDropdown || this.state.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
}
exports.default = Dropdown;
